import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import checkLock from "../../helpers/appLock/checkLock";
import setLock from "../../helpers/appLock/setLock";
import parseAppKey from "../../helpers/routeHelpers/parseAppKey";
import userHasPermission from "../../helpers/validation/userHasPermission";

class MobileControls extends React.Component {
	lockChecker = null;
	_isMounted = false;

	constructor(props) {
		super(props);
		this.state = {
			appLockStatus: null,
			lockToggle: false,
		};
	}

	async componentDidMount() {
		const appLockStatus = await checkLock();
		this.setState({ appLockStatus });
		this._isMounted = true;
	}

	componentDidUpdate(prevProps, prevState) {
		const appKey = parseAppKey();
		if (appKey !== prevState.appKey) {
			this.timeoutReset(100);
		}
		if (!prevProps.auth.user && this.props.auth.user) {
			this.checkLockStatus();
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (this.lockChecker) {
			clearTimeout(this.lockChecker);
		}
	}

	timeoutReset = (ms = 100) => {
		if (this.lockChecker) {
			clearTimeout(this.lockChecker);
		}
		this.lockChecker = setTimeout(() => {
			this.checkLockStatus();
		}, ms);
	};

	previewApp = () => {
		const { controlPanelActions } = this.props;
		controlPanelActions.toggleAppPreview();
	};

	checkLockStatus = async () => {
		const { appLockStatus } = this.state;
		const newAppLockInfo = await checkLock();

		if (!newAppLockInfo) {
			// route that we're not expecting, just bail out and clear the timeout
			clearTimeout(this.lockChecker);
		} else {
			if (
				this._isMounted &&
				(newAppLockInfo.global !== appLockStatus.global || newAppLockInfo.app !== appLockStatus.app)
			) {
				this.setState({ appLockStatus: newAppLockInfo });
			}

			this.timeoutReset(10000);
		}
	};

	toggleLockStatus = () => {
		if (setLock(this.state.appLockStatus)) {
			this.timeoutReset(100);
		}
	};

	render() {
		const { appLockStatus, lockToggle } = this.state;
		const { user } = this.props;

		const isLocked = appLockStatus && (appLockStatus.appIsLocked || appLockStatus.globalIsLocked);
		let validUser = false;
		if (user && user.user) {
			validUser = userHasPermission(user.user, "full");
		}

		return (
			<div className="mobile-controls">
				{appLockStatus ? (
					<div className={`lock${lockToggle ? " open" : ""}${isLocked ? " locked" : " unlocked"}`}>
						<span
							className="lock-icon"
							onClick={() => validUser && this.setState({ lockToggle: !this.state.lockToggle })}
						>
							<i className={`fal ${isLocked ? "fa-lock" : "fa-unlock"}`} />
						</span>
						<span
							className={`on-off-item${lockToggle ? " open" : ""}${isLocked ? " on" : ""}`}
							onClick={this.toggleLockStatus}
						>
							<div className="on-off-switch"></div>
						</span>
					</div>
				) : (
					<span>...</span>
				)}
				<button title="Preview App" className="preview" onClick={this.previewApp}>
					<i className="fal fa-play"></i>
				</button>
			</div>
		);
	}
}

MobileControls.propTypes = {
	controlPanelActions: PropTypes.object,
};

const mapStateToProps = state => ({
	auth: state.auth,
	user: state.user,
});

export default connect(mapStateToProps)(MobileControls);
